<p-toast></p-toast>
@if (isRunAsLibrary) {
  <st-loader></st-loader>
}

@if (currentRole == userRoles.Admin) {
  <app-emergency-alert></app-emergency-alert>
}

<div
  #persistentMapHost
  style="position: absolute; top: -9999px; left: -9999px; width: 1px; height: 1px; overflow: hidden"></div>

<main
  class="main pt-0"
  [ngClass]="{ 'overflow-auto': !env.getConfig().isRunAsLibrary, 'overflow-visible': env.getConfig().isRunAsLibrary }">
  <header class="header flex">
    <div class="header-element flex w-full align-items-center gap-spacing-md px-spacing-3xl py-spacing-md">
      <h1 class="page-title title-medium-bold text-primary-color min-w-max mb-0">Monitoring Center</h1>
      <span class="date body-medium-regular pl-spacing-md border-left-1 border-neutral-base-primary-border text-caption-color">{{ todayDate }}</span>
      @if (appSetting.viewChangeTimeZoneDll) {
        <p-select
          class="timezone-dropdown"
          [options]="timezoneOptions"
          (onChange)="setTimezone($event)"
          optionLabel="name"
          optionValue="id"
          [(ngModel)]="selectedTimezone"
          [disabled]="isPendingRides()"
          [style]="{ width: '200px' }"
          placeholder="Select Time Zone">
          <ng-template
            #item
            let-item
            let-selected="selected">
            <div class="w-full flex justify-content-between gap-spacing-xs align-items-center">
              {{ item.name }}
              @if (item.id == selectedTimezone) {
                <span>
                  <i class="icon-check size-icon-md"></i>
                </span>
              }
            </div>
          </ng-template>
        </p-select>
      }
    </div>

    <div
      class="header-element sm:flex hidden align-items-center justify-content-center p-spacing-xs"
      style="min-width: fit-content">
      <app-button
        iconStart="icon-television-simple"
        label="Cast to board"
        sizeClass="p-button-sm"
        severity="primary"
        (btnClick)="navigateToRidesBoard()"
        [textButton]="true">
      </app-button>
    </div>

    <div class="header-element flex w-full align-items-center justify-content-end gap-spacing-xl px-spacing-3xl py-spacing-md">
      @if (appSetting["hasPendingRidesPermission"]) {
        <button
          (click)="togglePendingRides()"
          class="split-button"
          pBadge
          [value]="pendingRidesCount().toString()"
          badgeSize="large"
          severity="danger"
          [ngClass]="{ 'pending-rides-active': isPendingRides() }">
          <span class="btn-icon text-light-color size-icon-sm icon-car"></span>
          <span>Pending Rides</span>
        </button>
      }
      @if (appSetting["hasGuardianMessagingPermission"]) {
        <button
          (click)="openMessagingDialog('guardian', true)"
          class="split-button active"
          pBadge
          [value]="guardiansMessagesCount"
          badgeSize="large"
          severity="danger">
          <span
            class="indicator"
            pTooltip="Service Online"
            [autoHide]="false"
            [tooltipOptions]="tooltipOptions">
            <span class="dot"></span>
          </span>
          <span class="btn-icon text-light-color size-icon-sm icon-chats-circle"></span>
          <span>Guardians</span>
        </button>
      }
      @if (appSetting["hasDriverMessagingPermission"]) {
        <button
          (click)="openMessagingDialog('contractor', true)"
          class="split-button active"
          pBadge
          [value]="partnersMessagesCount"
          badgeSize="large"
          severity="danger">
          <span
            class="indicator"
            pTooltip="Service Online"
            [autoHide]="false"
            [tooltipOptions]="tooltipOptions">
            <span class="dot"></span>
          </span>
          <span class="btn-icon text-light-color size-icon-sm icon-chats-circle"></span>
          <span>Drivers</span>
        </button>
      }
      @if (appSetting["hasSendScheduledNotification"]) {
        <button
          (click)="openNotificationQueue()"
          class="split-button active">
          <span class="btn-icon text-light-color size-icon-sm icon-bell"></span>
          <span>Notification Queue</span>
        </button>
      }
      @if (hasVisibleMenuItems()) {
        <div class="flex align-items-center gap-spacing-md">
          <div>
            <app-button
              [iconOnlyButton]="true"
              icon="icon-list"
              sizeClass="p-button-sm"
              severity="primary"
              (click)="openMenu($event, menuRef)"
              (keydown.enter)="openMenu($event, menuRef)">
            </app-button>
            <p-menu
              styleClass="header-menu"
              [appendTo]="'body'"
              #menuRef
              [model]="menu()"
              [popup]="true" />
          </div>
        </div>
      }
    </div>
  </header>
  <section class="statistics flex px-spacing-3xl pt-spacing-md overflow-x-auto">
    @for (item of statistics(); track $index) {
      <app-statistics
        (statClick)="setStatusFilter($event, filtersComponent)"
        class="col-2 py-0 mb-spacing-3xl"
        [style]="'--numOfStatistics: ' + (currentRole == userRoles.Client ? 6 : 7)"
        [type]="item.color"
        [title]="item.name | keyDisplayName"
        [value]="item.value.toString()"></app-statistics>
    }
  </section>

  <section class="page-controls px-spacing-md">
    <app-filters
      class="filter-component"
      [ngClass]="{ 'details-view': isDetailsView() }"
      #filtersComponent
      sectionTitle="Rides"
      [filters]="inputs"
      [filterActionsPlacement]="'end'"
      [AllowUpdateFilterControls]="true"
      [updatedControls]="updatedControls"
      [collapsed]="currentRole == userRoles.Client ? true : false"
      [numberOfResults]="numberOfResults()"
      (applyFilters)="Search($event)"
      (filtersClear)="Search($event)"
      (errorHappen)="showError($event)"
      [filterToggleIcon]="'icon-funnel-simple'">
      <div
        class="navigation-section"
        ngProjectAs="navigation-section">
        <p-selectButton
          [unselectable]="true"
          (onChange)="onViewChange($event)"
          class="p-button-sm"
          [options]="viewsOptions"
          [(ngModel)]="selectedView"
          optionLabel="name"
          optionValue="id">
          <ng-template
            let-item
            #item>
            <div class="flex align-items-center gap-spacing-xs">
              <i [class]="item.icon + ' size-icon-sm'"></i>
              <span class="select-btn-text">{{ item.name }}</span>
            </div>
          </ng-template>
        </p-selectButton>
      </div>
    </app-filters>
  </section>

  <section class="main-view">
    <router-outlet></router-outlet>
  </section>
</main>
